import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ApiListDataService} from './api.list-data.service';

@Injectable({
  providedIn: 'root'
})
export class ApiOrganizationByRoleLookupService extends ApiListDataService<any, any> {

  constructor(http: HttpClient) {
    super(http, '/Organization/ByRoleLookup');
  }

  getByName(name?: string) {
    let params = new HttpParams();
    if (name) {
      params = params.set('name', name);
    }
    return this.http.get<any[]>('v1/Organization/ByNameLookup', { params });
  }
}


